import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';
import parseApiErrors from '@rover/utilities/parseApiErrors';
import { t } from '@lingui/macro';
import i18n from '@rover/utilities/translation';
import { isTranslatable } from '@rover/utilities/i18n';

const CUSTOMER_SUPPORT_PHONE = Rover.context.customerSupportPhone;

export default class {
  static showToast({
    severity = 'info',
    message = '',
    container = '.js-alerts-container',
    showCloseButton = true,
  } = {}) {
    const parentContainer = $(container);
    const severityClass =
      ['success', 'info', 'warning', 'danger'].indexOf(severity) !== -1 ? severity : 'info';
    const closeButton = showCloseButton
      ? '<button type="button" class="close js-alert-close" data-dismiss="alert" aria-hidden="true">&times;</button>'
      : '';
    const rendered = `
            <div class="alert alert-${severityClass} padded fade in js-alert">
                ${closeButton}
                ${message}
            </div>
        `;
    parentContainer.append(rendered);
  }

  static showAlert({ attemptedAction = 'processing your request' } = {}) {
    // eslint-disable-next-line no-alert
    alert(
      i18n._(
        t`Oops, we encountered an error while ${attemptedAction}. Please try again shortly or contact Customer Support at ${CUSTOMER_SUPPORT_PHONE}.`
      )
    );
  }

  static alertApiError(err) {
    let formattedError;

    if (isTranslatable(err)) {
      formattedError = i18n._(err);
    } else if (typeof err === 'object') {
      formattedError = JSON.stringify(err);
    } else {
      formattedError = err;
    }

    if ($('.js-alerts-container').length) {
      this.showToast({ message: formattedError, severity: 'danger' });
      window.scrollTo($('.js-alerts-container'), 0);
    } else {
      this.showAlert({
        attemptedAction: i18n._(t`processing your request: ${formattedError}`),
      });
    }
  }

  static failedApiResponse(response) {
    const errors = parseApiErrors(response);
    if (errors === undefined || errors.length === 0) {
      this.alertApiError(
        i18n._(
          t`Oops, we encountered an error while processing your request. Please try again shortly or contact Customer Support ${CUSTOMER_SUPPORT_PHONE}`
        )
      );
      return;
    }
    errors.forEach(err => this.alertApiError(err));
  }
}



// WEBPACK FOOTER //
// ../utilities/Alerts.js